import jsonata from 'jsonata';

import { EvaluationError } from '../errors';
import { FunctionLoader } from '../functions/function-loader';
import { JSONataInput, TransformationContext, TransformationEvaluator } from '../interfaces';

/**
 * Evaluate JSONata expressions
 */
export class JSONataEvaluator implements TransformationEvaluator<JSONataInput> {
  constructor(private functionLoader: FunctionLoader = new FunctionLoader()) {}

  /**
   * Evaluate a JSONata expression
   * @param context The evaluation context
   *
   * @throws {EvaluationError} JSONata expression evaluation failed.
   */
  evaluate(context: TransformationContext<JSONataInput>): Promise<unknown> {
    try {
      const expression = jsonata(context.input.expression);
      return expression.evaluate(context.input.data, this.functionLoader.functions).catch(err => {
        throw new EvaluationError(`JSONata expression evaluation failed`, err);
      });
    } catch (err) {
      return Promise.reject(new EvaluationError(`JSONata expression evaluation failed`, err));
    }
  }
}
